import { useMergedRef } from "@mantine/hooks";
export default useMergedRef;
